module.exports = __webpack_public_path__ + "img/htEvent_introduce_banner_en.7dcffe50.jpg";